import { useCallback, useMemo, useState } from 'react'

export type OverlayState = {
  isOpen: boolean
  close: () => void
  open: (event?: React.UIEvent | MouseEvent | TouchEvent) => void
  toggle: (event?: React.UIEvent | MouseEvent | TouchEvent) => void
  anchorEl: EventTarget | null
}

export type UseOverlayOptions = {
  initiallyOpen?: boolean
}

export default function useOverlay({
  initiallyOpen = false,
}: UseOverlayOptions = {}): OverlayState {
  const [isOpen, setIsOpen] = useState(initiallyOpen)

  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null)

  const close = useCallback(() => {
    setIsOpen(false)
    setAnchorEl(null)
  }, [])

  const open = useCallback(
    (event?: React.UIEvent | MouseEvent | TouchEvent) => {
      if (event) setAnchorEl(event.target)
      setIsOpen(true)
    },
    [],
  )

  const toggle = useCallback(
    (event?: React.UIEvent | MouseEvent | TouchEvent) => {
      if (event) setAnchorEl(event.target)
      setIsOpen((prev) => !prev)
    },
    [],
  )

  return useMemo(
    () => ({
      isOpen,
      close,
      open,
      toggle,
      anchorEl,
    }),
    [anchorEl, close, isOpen, open, toggle],
  )
}
